<template>
  <f7-popover class="otherActions" :backdrop="false">
    <f7-list dividers-ios strong-ios media-list no-chevron>
      <f7-list-item link="#" class="searchbar-enable" data-searchbar=".searchbar-message" popover-close
        :title="$t('common.search')">
      </f7-list-item>

      <f7-list-item link="#" popover-close @click="openContactDetailPanel()">
        <div v-if="groupType === 'PERSONAL'">
          {{ $t("tamtammessage.contactInfo") }}
        </div>
        <div v-else-if="groupType === 'GROUP'">
          {{ $t("tamtammessage.groupInfo") }}
        </div>
        <div v-else-if="groupType === 'SUBGROUP'">
          {{ $t("tamtammessage.subgroupInfo") }}
        </div>
      </f7-list-item>
      <f7-list-item link="#" @click="makeSelectable()" popover-close
        :title="$t('tamtammessage.selectMessages')"></f7-list-item>
      <f7-list-item link="#" popover-close :title="$t('tamtammessage.deleteChat')"
        @click="deleteChat(group)"></f7-list-item>
      <f7-list-item link="#" popover-close :title="$t('tamtammessage.exitGroup')" v-if="groupType !== 'PERSONAL'"
        @click="leaveGroup(group)"></f7-list-item>
    </f7-list>
  </f7-popover>

  <f7-sheet class="messageActionsSheet" style="height: auto; --f7-sheet-bg-color: #fff" swipe-to-close :backdrop="false">
    <f7-list dividers-ios strong-ios media-list no-chevron>
      <f7-list-item v-if="currentMessage.groupType !== 'PERSONAL'" link="#" sheet-close :title="$t('tamtammessage.reply')"
        @click="replyMsg(currentMessage)"></f7-list-item>
      <f7-list-item v-if="currentMessage.groupType === 'PERSONAL'" link="#" sheet-close :title="$t('tamtammessage.reply')"
        @click="replyMsg(currentMessage)"></f7-list-item>
      <f7-list-item v-if="currentMessage.groupType !== 'PERSONAL' &&
        currentMessage.type === 'received'
        " link="#" sheet-close :title="$t('tamtammessage.replyPrivately')"
        @click="replyMsgPrivately(currentMessage)"></f7-list-item>
      <f7-list-item link="#" sheet-close :title="$t('tamtammessage.forwardMessage')"
        @click="forwardMsg(currentMessage)"></f7-list-item>
      <f7-list-item link="#" sheet-close :title="currentMessage?.type === 'sent'
          ? $t('tamtammessage.deleteMessageForMe')
          : $t('tamtammessage.deleteMessage')
        " @click="deleteForMe(currentMessage)"></f7-list-item>
      <f7-list-item v-if="currentMessage?.type === 'sent'" link="#" sheet-close
        :title="$t('tamtammessage.editMessage')" @click="$emit('edit-message', currentMessage)"></f7-list-item>
      <f7-list-item v-if="currentMessage?.type === 'sent'" link="#" sheet-close
        :title="$t('tamtammessage.deleteMessageForAll')" @click="deleteForAll(currentMessage)"></f7-list-item>

      <f7-list-item link="#" sheet-close :title="$t('tamtammessage.selectMessage')"
        @click="selectMessage(currentMessage)"></f7-list-item>

      <f7-list-item link="#" sheet-close :title="$t('tamtammessage.copyMessage')"
        @click="copyMsg(currentMessage)"></f7-list-item>
    </f7-list>
  </f7-sheet>
</template>
<style scoped></style>
<script setup>
import { f7, theme } from "framework7-vue";
import { storeToRefs } from "pinia";
import { useMessageStore } from "../../js/pinia-stores/message.js";
import { useAuthStore } from "../../js/pinia-stores/auth.js";
import { useTabletScreen } from "../../js/composables/useMediaQuery.js";
import { useAccountStore } from "../../js/pinia-stores/account.js";
import { useMessage } from "@/js/composables/useMessage.js";

defineEmits(["edit-message"]);

const props = defineProps({
  f7route: Object,
  f7router: Object,
  groupType: String,
  currentMessage: Object,
});

const messageStore = useMessageStore();
const authStore = useAuthStore();
const accountStore = useAccountStore();

const { chatUser, message, chatUserList, messageList, group, groupList, subGroup, subGroupList, blockedUser, blockedUserList, blockedUserMsg, groupAdmin, groupAdminList, counterPartUser, counterPartUserList, groupParticipantList, messageIsSelected, selectedMessages } = storeToRefs(messageStore);
const { phoneNumberDetail, mobilePhoneError, profile, isNativePlatform, locale, documentsUrl } = storeToRefs(authStore);
const isTablet = useTabletScreen().matches;
const { primaryAccount, businessAccount, userDetail, searchedUser } = storeToRefs(accountStore);

const { openContactDetailPanel, makeSelectable, deleteChat, leaveGroup, replyMsg, replyMsgPrivately, forwardMsg, deleteForMe, deleteForAll, selectMessage, copyMsg } = useMessage({
  f7route: props.f7route,
  f7router: props.f7router,
  isTablet,
  profile,
  chatUser,
  group,
  groupList,
  selectedMessages,
  messageIsSelected,
});
</script>
